import SystemSettingDisplayReducer from 'store/system-setting/display/reducers';

export default SystemSettingDisplayReducer;
